/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  code3Formatter,
  createDefaultGridModel,
  ROW_DIRTY_CLASS,
} from '@gh/common-internal-shared';
import { NumberTypes, State } from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';
import {
  buildNumberColumn,
  GridModel,
  GridOptionsExt,
  ManualGridDefinitionWithModel,
} from '@gh/core-ui-grid';
import { ColDef } from 'ag-grid-community';
import { isNil } from 'lodash';
import { getHpeCostCenterId, HpeCostCenter } from '../../../resources/hpe-details.model';
import { HpeDetailsState, queryHpeEditable, queryHpeIsCccId } from '../hpe-details.state';

@Injectable()
export class HpeDetailsCcGridDefinition extends ManualGridDefinitionWithModel {

  constructor(private translationService: TranslationService,
              private state: State<HpeDetailsState>) {
    super();
  }

  buildGridModel(): GridModel {
    return createDefaultGridModel({
      editable: this.state.project(queryHpeEditable),
      getId: getHpeCostCenterId,
    });
  }

  buildGridOptions(): GridOptionsExt {
    return {
      rowSelection: { mode: 'singleRow', enableClickSelection: true, checkboxes: false },
      defaultColDef: {
        sortable: false,
      },
      rowClassRules: {
        [ROW_DIRTY_CLASS]: ({ data }: { data: HpeCostCenter }) => !isNil(data.dirtyType),
      },
    };
  }

  buildColumnDefs(): ColDef[] {
    return [{
      field: 'code',
      headerName: this.translationService.get('lbl_number'),
      width: 100,
      sort: 'asc',
      valueFormatter: code3Formatter,
    }, {
      field: 'name',
      headerName: this.translationService.get('lbl_description'),
      width: 150,
    }, {
      field: 'cost',
      headerName: this.translationService.get('lbl_order_cost_dollar'),
      width: 120,
      ...buildNumberColumn(NumberTypes.Price),
      valueGetter: ({ data }: { data: HpeCostCenter }) =>
        this.state.project(queryHpeIsCccId, getHpeCostCenterId(data)) ? void 0 : data.cost,
    }];
  }
}
